// React and related imports
import React from 'react';

// Flowbite components
import { Checkbox, Label } from 'flowbite-react';

// i18 Translation
import { TFunction } from 'i18next';

// Types and Interfaces
import { WeekDays } from '../../common/enums/WeekDays';
import { ContextState } from '../../hooks/useContentContextState';

interface DaySelectionProps {
  t: TFunction<'translation', undefined>;
  contextState: ContextState;
  updateField: (field: keyof ContextState, value: WeekDays[]) => void;
  validateField: (field: string, value: WeekDays[]) => void;
}

export const DaysSelection: React.FC<DaySelectionProps> = ({
  t,
  contextState,
  updateField,
  validateField,
}) => {
  const handleDayChange = (day: WeekDays) => {
    if (contextState?.days.includes(day)) {
      updateField(
        'days' as keyof ContextState,
        contextState?.days.filter((d) => d !== day)
      );
      validateField(
        'days',
        contextState?.days.filter((d) => d !== day)
      );
    } else {
      if (contextState) {
        updateField('days' as keyof ContextState, [...contextState.days, day]);
        validateField('days', [...contextState.days, day]);
      }
    }
  };

  return (
    <div>
      <Label htmlFor="weekDays">
        {t('contentContext.selectDays')}
        <span className="ms-1 text-red-500">*</span>
      </Label>
      <div className="mt-4 flex flex-wrap gap-x-6 gap-y-2">
        {Object.entries(WeekDays).map(([dayName, dayValue]) => (
          <div key={`day-${dayValue}`} className="flex items-center space-x-2">
            <Checkbox
              id={`day-${dayValue}`}
              className="me-2"
              value={dayValue}
              checked={
                contextState?.days.includes(dayValue as WeekDays) || false
              }
              onChange={() => handleDayChange(dayValue as WeekDays)}
            />
            <Label htmlFor={`day-${dayValue}`} className="weekDays">
              {t(`weekDays.${dayName}`)}
            </Label>
          </div>
        ))}
      </div>
    </div>
  );
};
